/**
 * Created by mukund on 7/14/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('CollectionController', function ($scope, $rootScope, $http, $state, $filter, $window, $timeout, FileUploader, Principal, CollectionService, SearchService, AssetService, atmosphereService, Auth, Tenant, SchedulerService, BaseFileService) {
        Principal.identity().then(function(account) {
            // Determine if a user is logged in
            $scope.isAuthenticated = Principal.isAuthenticated;
            $scope.isContentManager = false;
            $scope.enableScheduler = $scope.isAuthenticated();
            $http({
                method: 'GET',
                url: 'api/properties?name=ENABLE_SCHEDULER'
            }).then(function successCallback(response) {
                if (response.data.value != null) {
                    $scope.enableScheduler = response.data.value === 'false' ? false : true;
                }
            });

            $scope.enableAddMedia = $scope.isAuthenticated();
            $http({
                method: 'GET',
                url: 'api/properties?name=FEATURE_FLAG_ENABLE_UPLOADER_FOR_INSTRUCTORS'
            }).then(function successCallback(response) {
                if (response.data.value != null) {
                    var enableUploaderForInstructors = response.data.value === 'false' ? false : true;
                    if (!enableUploaderForInstructors && $scope.account.authorities.indexOf("ROLE_ADMIN") == -1) {
                        $scope.enableAddMedia = false;
                    }
                }
            });

            $http({
                method: 'GET',
                url: 'api/user/iscontentmanager'
            }).then(function successCallback(response) {
                $scope.isContentManager = response && response.data == 'true';
            });

            // aahmed: 06-23-2021: ENG-4000: Modified checks to see if user is in iframe and is coming in via lmsCourse state
            if ($state.params.isLTI !== '1' && $rootScope.toState.name === 'lmsCourse') {
                if ($scope.isAuthenticated()) {
                    Auth.logout();
                }

                $rootScope.previousStateName = undefined;

                $rootScope.previousStateParams = undefined;

                Tenant.info().then(function (data) {
                    var managerUrl = data.managerUrl;
                    // logout of MediaManager and redirect to PPnP
                    if (managerUrl) {
                        $http.get(managerUrl + '/j_acegi_logout', {withCredentials: true});
                        $window.location.href = managerUrl.substring(0, managerUrl.lastIndexOf('/'));
                    }
                });

            } else {
                $scope.account = account;

                $scope.errors = [];
                $scope.clickUploader = function () {
                    $scope.errors = [];
                    $('#single-uploader-input').click();
                };

                if ($state.params.collectionId) {
                    $scope.collectionContentsPerRow = 4;
                    $scope.collectionContentsPerPage = 8;

                    $scope.submissions = {new: 0};

                    $scope.pagination = {
                        current: 1
                    };


                    var isAtmosphereSetup = false;
                    var defaultContentMaxHeight = 360,
                        defaultContentMinHeight = 360,
                        //360 for grid view
                        //180 for list view
                        // defaultContentMinHeight = 250 (card size before 6.12),
                        contentHeight = defaultContentMaxHeight;

                    // Sets the the default view to thumbnails (grid) for the collection content
                    $scope.activeView = 'grid';

                    $scope.content = {
                        type: '',
                        items: [],
                    };

                    $scope.showFilterAndSort = false;
                    $scope.inlineFolderCreate = false;

                    $scope.breadcrumb = {show: false};

                    $scope.render = false;




                    $scope.search = {query: "", activateSearch: false};

                    // Options for filtering collection contents
                    $scope.filters = [
                        {id: 'fav', name: 'Favorites', selected: false},
                        {id: 'fol', name: 'Folders', selected: false},
                        {id: 'aud', name: 'Audio', selected: false},
                        {id: 'zip', name: 'Composites', selected: false},
                        {id: 'doc', name: 'Documents', selected: false},
                        {id: 'img', name: 'Images', selected: false},
                        {id: 'pod', name: 'Podcasts', selected: false},
                        {id: 'vid', name: 'Video', selected: false}
                    ];

                    // Options for sorting collection contents
                    $scope.sorts = [
                        {id: 'accesses', name: 'Accesses'},
                        {id: 'contributor', name: 'Contributor'},
                        {id: 'publishedDate', name: 'Published Date'},
                        {id: 'title', name: 'Title'}
                    ];

                    $scope.activeSortId = "publishedDate";

                    $scope.filterAndSortText = "Filter / Sort";

                    $scope.showSearchResults = false;

                    $scope.isLMSCourse = false;

                    $scope.filterApplied = false;

                    $scope.copyOf = {
                        courseName: ''
                    };

                    // Obtain the Parent Collection Type from the URL
                    var collectionType = $state.current.name.toLowerCase();
                    if ($state.current.name === 'lmsCourse') {
                        collectionType = 'course';
                        $scope.isLMSCourse = true;
                    }

                    var logger = function(msg) {
                        var activated = false;

                        if(activated) {
                            console.log(msg);
                        }
                    }

                    // For every page reload, fetch the parent collection and its assets
                    var getParent = $scope.getParent = function () {
                        logger('getParent')
                        CollectionService.GetCollection.get({
                            cid: $state.params.collectionId,
                            type: collectionType.toUpperCase()
                        }, function (parentCollection) {

                            // This is the top level collection
                            $scope.parentCollection = parentCollection;

                            // This is the collection that the user is currently viewing (could be the top level collection or sub-collection)
                            $scope.currentCollection = parentCollection;
                            $scope.currentCollection.pathLength = parentCollection.path.split('/').length;

                            // The $timeout will run after this $digest cycle completes
                            $timeout(function () {
                                var calculateRows = function(){
                                    var courseHeaderHeight = angular.element('#collection-header').outerHeight(),
                                        courseNavHeight = angular.element('#pnp-nav').outerHeight(),
                                        controlPanelHeight = angular.element('#control-panel').outerHeight(),
                                        courseFooterHeight = angular.element('#collection-footer').outerHeight(),
                                        courseContainerHeight = $window.innerHeight,
                                        availableassetspace = courseContainerHeight - (courseHeaderHeight + courseNavHeight + controlPanelHeight + courseFooterHeight);
                                        // rowsToShow = Math.floor(availableassetspace / defaultContentMinHeight),
                                    var rowsToShow;
                                    var contentHeightCalculated = availableassetspace / rowsToShow - 20;

                                    contentHeight = (contentHeightCalculated > defaultContentMaxHeight) ? defaultContentMaxHeight : contentHeightCalculated;

                                    //Forcing to always show 2 lines.
                                    //It works even if there are less than 4 items.
                                    rowsToShow = 2;
                                    $scope.rowsToShow = rowsToShow;

                                    var currentAssetCount = ($scope.pagination.current - 1) * $scope.collectionContentsPerPage + 1;
                                    var newContentsPerPage = $scope.collectionContentsPerRow * rowsToShow;

                                    // Only fetch assets from the server if necessary
                                    if(newContentsPerPage !== $scope.collectionContentsPerPage || !$scope.currentCollection.contents) {
                                        $scope.collectionContentsPerPage = newContentsPerPage;
                                        var pageToView = Math.ceil(currentAssetCount / $scope.collectionContentsPerPage);
                                        $scope.pagination.current = pageToView;
                                        getCollectionContent(pageToView);
                                    } else {
                                        makeContentResponsive(null);
                                    }
                                };

                                // Calculate how many rows to show within the PnP LMS iframe
                                if($scope.isLMSCourse){
                                    calculateRows();
                                    // Run the calculations when the iframe resizes
                                    var windowWidth = $(window).width();
                                    angular.element($window).on('resize', function(){
                                        if($(window).width() !== windowWidth){
                                            if($scope.activeLink === 'pnp' && $scope.activeView === 'grid'){
                                                calculateRows();
                                            }
                                        }
                                    });
                                }
                            });

                            // Get the featured asset
                            if ($scope.parentCollection.featuredAssetId) {
                                CollectionService.GetFeaturedAsset.get({cid: $scope.parentCollection.cid}, function (featuredAsset) {
                                    $scope.currentCollection.featuredAsset = featuredAsset;
                                });
                            }

                            CollectionService.GetCollectionTree.get({cid: $state.params.collectionId}, function (tree) {
                                $scope.collectionTree = tree;
                                $scope.collectionTree.show = false;
                                $scope.currentCollection.crumbs = generateCrumbs($scope.currentCollection.cid, $scope.currentCollection.path);
                                if($scope.currentCollection.pathLength >= 3){
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                } else {
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                }
                            });

                            $scope.pagination.current = 1;
                            // Only fetch content here if the user is viewing the course in the standalone app.
                            if(!$scope.isLMSCourse) {
                                getCollectionContent(1);
                            }

                            if (parentCollection.type === 'course' && parentCollection.acl.indexOf('W') !== -1) {
                                CollectionService.GetNewMediaInboxSubmissions.get({cid: $state.params.collectionId}, function (response) {
                                    $scope.submissions.new = response.newSubmissions;
                                });
                                if (!isAtmosphereSetup) {
                                    atmosphereSetup();
                                }
                            }

                            if(collectionType === 'course'){
                                SchedulerService.checkAvailability.get({baseCollectionId: parentCollection.cid}, function(response){
                                    $scope.allowScheduling = response.result;

                                    SchedulerService.getEventCountForCollection.get({baseCollectionId: parentCollection.cid}, function(response){
                                        $scope.hasEvents = response.count && response.count > 0;
                                    });
                                });
                            }
                        });
                    };

                    getParent();

                    $scope.cardBgColorOnFocus = '#EDF8FF';

                    var generateCrumbs = function (cid, path) {
                        logger('generateCrumbs')
                        var crumbs = [];
                        if (path) {
                            var parents = path.split('/').slice(3);
                            if (parents.length) {
                                angular.forEach($scope.collectionTree.children, function (node) {
                                    getCrumbs(node, crumbs, cid, parents);
                                });
                            }
                        }
                        return crumbs;
                    };

                    // recursive function that gets all parent nodes of a collection from the collection tree
                    var getCrumbs = function (node, crumbs, cid, parents) {
                        logger('getCrumbs')
                        if (node.cid && parents.indexOf(node.cid) !== -1) {
                            crumbs.push({title: node.title, cid: node.cid});
                        }
                        angular.forEach(node.children, function (child) {
                            getCrumbs(child, crumbs, cid, parents);
                        });
                    };

                    // This is run whenever the user navigates within a collection
                    $scope.openContent = function (content) {
                        logger('openContent')
                        if (content.type === 'Collection') {
                            $scope.resetFilterAndSort();
                            CollectionService.GetCollection.get({
                                cid: content.xid,
                                type: collectionType.toUpperCase()
                            }, function (collection) {
                                $scope.currentCollection = collection;
                                $scope.currentCollection.pathLength = collection.path.split('/').length;
                                $scope.currentCollection.crumbs = generateCrumbs(collection.cid, collection.path);

                                if($scope.currentCollection.pathLength >= 3){
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                    $timeout(function(){
                                        var collectionTitleElt = angular.element('#current-collection-title-breadcrumb');
                                        $scope.currentCollection.tooltipState = collectionTitleElt[0] && (collectionTitleElt[0].scrollWidth > collectionTitleElt.innerWidth());
                                        collectionTitleElt.hover(function(){
                                            $scope.currentCollection.tooltipState = collectionTitleElt[0] && (collectionTitleElt[0].scrollWidth > collectionTitleElt.innerWidth());
                                            $scope.$apply();
                                        });
                                    });
                                } else {
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                }

                                $scope.pagination.current = 1;
                                getCollectionContent(1);

                                if(!collection.contents) {
                                    $('.row.list-group').css('height', '')
                                    $('.row.list-group').css('min-height', '')
                                    $('.row.list-group').css('max-height', '')
                                }
                                // makeContentResponsive(null);
                            });
                        } else {
                            if ($state.current.name === 'lmsCourse') {
                                $state.go('lmsPlayback', {
                                    collectionType: collectionType,
                                    collectionId: content.parent.cid,
                                    assetId: content.xid
                                });
                            } else {
                                $state.go('playback', {
                                    collectionType: collectionType,
                                    collectionId: content.parent.cid,
                                    assetId: content.xid
                                });
                            }
                        }
                    };


                    // This is used to fetch all content inside a collection - assets and sub-collections
                    var getCollectionContent = $scope.getCollectionContent = function (page) {
                        logger('getCollectionContent');

                        CollectionService.GetCollectionContent.get({
                            cid: $scope.currentCollection.cid,
                            offset: (page - 1) * $scope.collectionContentsPerPage,
                            limit: $scope.collectionContentsPerPage,
                            fav: $filter('filter')($scope.filters, {id: 'fav'}, true)[0].selected,
                            fol: $filter('filter')($scope.filters, {id: 'fol'}, true)[0].selected,
                            pod: $filter('filter')($scope.filters, {id: 'pod'}, true)[0].selected,
                            aud: $filter('filter')($scope.filters, {id: 'aud'}, true)[0].selected,
                            vid: $filter('filter')($scope.filters, {id: 'vid'}, true)[0].selected,
                            img: $filter('filter')($scope.filters, {id: 'img'}, true)[0].selected,
                            doc: $filter('filter')($scope.filters, {id: 'doc'}, true)[0].selected,
                            zip: $filter('filter')($scope.filters, {id: 'zip'}, true)[0].selected,
                            sortOn: $scope.activeSortId
                        }, function (collectionContentList) {
                                $scope.allItemsCollection = collectionContentList.contents;

                            if(collectionContentList.totalContents === 0) {
                                $($('#selectAllCheck').children()[0]).attr("disabled", true);
                                $('#selectAllCheck').css("cursor", 'not-allowed');
                                makeContentResponsive(null);
                            } else {
                                $($('#selectAllCheck').children()[0]).removeAttr("disabled");
                                $('#selectAllCheck').css("cursor", 'pointer');
                            }

                            //uncheck all checkboxes
                            $('input.custom-checkbox').attr('checked', false);
                            $('#selectAllCheck input').attr('checked', false);
                            $scope.manageCheckAllState();

                            $('#inlineFolderCreate').hide();
                            $scope.currentCollection.contents = collectionContentList.contents;
                            $scope.currentCollection.totalContents = collectionContentList.totalContents;
                            $scope.showSearchResults = false;

                            if($scope.parentCollection.acl.indexOf('W') !== -1
                                && $scope.currentCollection.totalContents === 0
                                && !$scope.filterApplied
                                && $scope.parentCollection.cid === $scope.currentCollection.cid
                                && collectionType === 'course'){
                                    CollectionService.getCollections({
                                        type: 'COURSE',
                                        paginated: true,
                                        limit: 10,
                                        offset: 0,
                                        rw: true
                                    }).then(function(response){
                                        if (response.collections && response.collections.length > 0) {
                                            var filteredCourses = $filter('filter')(response.collections, {cid: '!' + $scope.parentCollection.cid}, true);
                                            if (filteredCourses.length) {
                                                $scope.copyWizardAvailable = true;
                                                $scope.loadComponent('copywizard');
                                                $scope.oldCourses = response;
                                            } else {
                                                $scope.loadComponent('pnp');
                                                makeContentResponsive(null);
                                            }
                                        }
                                        showCourseDescriptionEllipsis();
                                    });
                            } else {
                                if(collectionType === 'course') {
                                    if ($scope.copyOf.courseName) {
                                        $scope.copyWizardAvailable = false;
                                        // Only show the alert if the user is on the parent collection (and not a subcollection)
                                        $scope.showCourseCopyAlert = $scope.parentCollection.cid === $scope.currentCollection.cid;
                                        $timeout(function(){
                                            $scope.showCourseCopyAlert = false;
                                            $scope.copyOf.courseName = '';
                                        }, 10000);
                                    }
                                }

                                $scope.loadComponent('pnp');

                                //wait until there's content
                                var timeoutId = setInterval(function(){
                                    if($('.asset-card').length) {
                                        if(!contentLoaded) {
                                            contentLoaded = true;
                                        }
                                            makeContentResponsive('getCollectionContent');
                                        clearInterval(timeoutId);
                                    }

                                    setCheckAllCheckboxState();

                                }, 100)

                                showCourseDescriptionEllipsis();
                            }
                            $('#selectAllCheck input').prop('checked', false);
                        });

                        $scope.manageCheckAllState();

                    };

                    var contentLoaded = false;

                    var setCheckAllCheckboxState = function() {
                        var items = $('.pnp-item:not(#inlineFolderCreate)');
                        var checkAllCheckbox = $('#selectAllCheck input')[0];

                        if(items.length === 0) {
                            checkAllCheckbox.classList.remove('custom-checkbox');
                            checkAllCheckbox.classList.add('custom-checkbox-disabled');
                        } else {
                            checkAllCheckbox.classList.remove('custom-checkbox-disabled');
                            checkAllCheckbox.classList.add('custom-checkbox');
                        }
                    }

                    $scope.disableButton = function () {
                        logger('disableButton')
                        return $('.item-checkbox:checked').length === 0;
                    };

                    var makeContentResponsive = function(caller){
                        logger('makeContentResponsive')

                        $timeout(function() {
                            setContentWidthForGrid();
                            setContentWidthForList();
                            setContentWidthForNewFolder();
                            alignOverflowMenu();
                        }, 250)

                        if($scope.isLMSCourse){
                            $timeout(function () {
                                if($scope.activeView === 'list') {
                                    if ($scope.currentCollection && $scope.currentCollection.contents) {
                                        for(var i = 0; i < $scope.currentCollection.contents.length; i++) {
                                            if($scope.currentCollection.contents[i].type !== 'Collection') {
                                                $($('.pnp-item.list-group-item')[i + 1]).height(194);
                                            } else {
                                                $($('.pnp-item.list-group-item')[i + 1]).height(172);
                                            }
                                        }
                                    }

                                    $('.pnp.container.cardcontainer').height('');
                                    $('#collection-footer').css('margin-top', '');
                                    $('#collection-footer').css('height', '');
                                    $('.row.list-group').css('height', '');
                                    $('.row.list-group').css('min-height', '');
                                    $('.row.list-group').css('max-height', '');

                                } else if($scope.activeView === 'grid') {
                                    setCardHeight(360);
                                    // setContainerHeight();

                                    if($scope.currentCollection && $scope.currentCollection.contents && $scope.currentCollection.contents.length === 0) {
                                        $('.pnp.container.cardcontainer').css('justify-content', 'flex-start');
                                    } else {
                                        $('.pnp.container.cardcontainer').css('justify-content', 'space-between');
                                    }

                                    calculateAssetsHeight();
                                    // calculateSpaceBetweenItems(caller);
                                }
                            }, 0);

                            if ($scope.activeView === 'list') {
                                $('.single-course-wrapper').height('');
                            }
                        }
                    };

                    var calculateAssetsHeight = function() {
                        $('.assets').css('opacity', 1);
                        $('.single-course-wrapper').height('100%');
                        $('.cardcontainer').height('100%');
                        $('.assets').height('100%');
                    }

                    var calculatedItemsDistance;

                    //Determines if it is the first time we call calculateSpaceBetweenItems (CSBI)
                    $scope.isFirstCSBICall = true;
                    $scope.isSmallScreen = null;
                    $scope.isBigScreen = null;
                    var calculateSpaceBetweenItems = function (caller) {
                        logger('calculateSpaceBetweenItems')

                        if(!$scope.isFirstCSBICall || caller === 'getCollectionContent') {

                            //1 - set correct CSS format
                            if ($scope.currentCollection && $scope.currentCollection.contents && $scope.currentCollection.contents.length > 8) {
                                $('.pnp.container.cardcontainer').css('justify-content', 'space-between');
                            } else {
                                $('.pnp.container.cardcontainer').css('justify-content', 'flex-start');
                            }

                            //2 - set height according to screen size
                            //wait until we have assets
                            if (caller === 'changeView') {
                                $('.assets').show();
                            }
                            var intervalAssets = setInterval(function () {
                                if ($('.assets').is(':visible')) {
                                    clearInterval(intervalAssets);

                                    //all assets are visible
                                    //check if, assets count fit in container's height
                                    //if big screen, 100vh
                                    if ($('.content-wrapper').height() > $('.single-course-wrapper').height()) {
                                        if($scope.isBigScreen === null) {
                                            $scope.isBigScreen = true;
                                        }

                                        $('.single-course-wrapper').css('height', '100vh');
                                    } else if ($('.content-wrapper').height() < $('.single-course-wrapper').height()) {
                                        if ($scope.isSmallScreen === null) {
                                            $scope.isSmallScreen = true;
                                        }
                                        //if small screen, no height
                                        $('.single-course-wrapper').css('height', '');
                                    } else if ($('.content-wrapper').height() === $('.single-course-wrapper').height()) {
                                        //if already executed
                                        //for small screen, coming back from empty folder
                                        if($scope.isSmallScreen) {
                                            $('.single-course-wrapper').css('height', '');
                                        }
                                    }

                                    //4 - Get the distance between items given by flexbox
                                    var itemsDistance = 24;
                                    var intervalDistance = setInterval(function () {
                                        if (caller === 'getCollectionContent') {
                                            //there's assets
                                            $('.assets').show();
                                            if ($('.assets').offset().top > 0) {
                                                itemsDistance = $('.assets').offset().top - $('.button-container').offset().top;
                                            }
                                            calculatedItemsDistance = itemsDistance;
                                        }

                                        if (calculatedItemsDistance) {
                                            itemsDistance = calculatedItemsDistance;
                                        }

                                        if ($('.button-container').offset().top > 0) {
                                            clearInterval(intervalDistance);

                                            //5 - Calculate the distance between cards
                                            var cardsDistance = 20; //default margin
                                            cardsDistance -= (cardsDistance - itemsDistance) / 2;

                                            var intervalId = setInterval(function () {
                                                if ($scope.currentCollection && $scope.currentCollection.contents && $scope.currentCollection.contents.length > 4) {
                                                    if ($($('.asset-card:not(.create-folder)')[4]).offset()) {

                                                        if ($scope.currentCollection.contents.length > 8) {
                                                            var containerHeight = 3 * (cardsDistance + 360);
                                                            $('.row.list-group.assets').css('height', containerHeight);
                                                        } else if ($scope.currentCollection.contents.length > 4) {
                                                            //As sometimes cardsDistance is NaN, and it runs twice,
                                                            // we only change height if cardsDistance is set.
                                                            if (!isNaN(cardsDistance)) {
                                                                var containerHeight = 2 * (cardsDistance + 360);
                                                                $('.row.list-group.assets').css('height', containerHeight);
                                                            }
                                                        }

                                                        clearInterval(intervalId);

                                                        if($('#inlineFolderCreate').is(':visible')) {
                                                            if($scope.rowsToShow === 3 && $('.item.pnp-item').length > 12) {
                                                                $('.item.pnp-item').last().hide();
                                                            } else if($scope.rowsToShow === 2 && $('.item.pnp-item').length > 8) {
                                                                $('.item.pnp-item').last().hide();
                                                            } else if($scope.rowsToShow === 1 && $('.item.pnp-item').length > 4) {
                                                                $('.item.pnp-item').last().hide();
                                                            }
                                                        }

                                                        $('.assets').css('opacity', '1');
                                                    }
                                                } else if ($scope.currentCollection && $scope.currentCollection.contents && $scope.currentCollection.contents.length <= 4) {
                                                    clearInterval(intervalId);
                                                    var containerHeight = cardsDistance + 360;
                                                    $('.row.list-group.assets').css('height', containerHeight);
                                                    $('.assets').css('opacity', '1');
                                                }

                                                $('.list-group.assets').show();
                                                $scope.isFirstCSBICall = false;
                                            }, 100)
                                        }
                                    }, 50)
                                }
                            }, 100)

                            //3 - wait until we have items in collection
                            var intervalCollection = setInterval(function () {
                                if ($scope.currentCollection && $scope.currentCollection.contents) {
                                    if ($('.emptyfolder').length) {
                                        $('.row.list-group.assets').css('height', '');
                                        $('.row.list-group.assets').css('min-height', '');
                                        $('.row.list-group.assets').css('max-height', '');

                                        return;
                                    }

                                    clearInterval(intervalCollection);
                                }
                            }, 100)

                        }
                    }

                    var alignOverflowMenu = function() {
                        logger('alignOverflowMenu')
                        var itemsCount = $scope.currentCollection && $scope.currentCollection.contents ? $scope.currentCollection.contents.length : 0;

                        if($scope.activeView === 'grid') {
                            for(var i = itemsCount; i > 4; i--) {
                                $($('.menu')[i]).css({'top': '170px', 'right': '45px'});
                            }

                            if(itemsCount <= 4) {
                                $('.menu').css({'top': '170px', 'right': '45px'});
                            }
                        } else if($scope.activeView === 'list') {
                            $('.menu').last().css({'top': '18px', 'right': '41px'});

                            if(!$scope.isLMSCourse) {
                                $('.pnp-item').last().css('margin-bottom', '40px');
                            }
                        }
                    }

                    var setContainerHeight = function () {
                        logger('setContainerHeight')
                        var contentLoaded = false;

                        var tries = 0;
                        var intervalId = setInterval(function() {
                            tries++;
                            var collectionHeaderHeight = $('#collection-header').height();
                            var lmsTopHeight = $('.ic-app-nav-toggle-and-crumbs').height() ? $('.ic-app-nav-toggle-and-crumbs').height() : 70; //specific for Canvas
                            var availableHeight = window.innerHeight - lmsTopHeight;
                            var rowListGroupHeight = $('.row.list-group').height();
                            var createFolderHeight = $('.create-folder').length ? $('.create-folder').height() : 0;
                            var buttonContainerHeight = $('.button-container').height();
                            var controlPanelHeight = $('#control-panel').height();
                            var pnpNavHeight = $('#pnp-nav').height();

                            if(
                                ($scope.currentCollection && $scope.currentCollection.contents && $scope.currentCollection.contents.length) ||
                                $('.create-folder').is(':visible') ||
                                tries === 20
                            ) {
                                rowListGroupHeight = Math.max(344, rowListGroupHeight);
                                contentLoaded = true;
                            }

                            if(contentLoaded) {
                                //var spaceForFooter = Math.floor(availableHeight - rowListGroupHeight - createFolderHeight - 24 - buttonContainerHeight - controlPanelHeight - pnpNavHeight - collectionHeaderHeight - 26);
                                $('#collection-footer').height('');
                                var cardHeight = $($('.item.pnp-item')[1]).height() ? $($('.item.pnp-item')[1]).height() : $('.item.pnp-item').height();

                                if($('.emptyfolder').is(':visible')) {
                                    cardHeight = 0;
                                }

                                //Set the height of the content on screen if it's the Pick and Play tab, i.e. there are
                                //asset cards. If it's the Media Inbox tab, it shouldn't change height.
                                $('.row.list-group .asset-card.create-folder').parents('.row.list-group').height(
                                    $scope.rowsToShow * (cardHeight + 10)
                                );

                                clearInterval(intervalId);
                            }
                        }, 50);
                    }

                    var showCourseDescriptionEllipsis = function(){
                        logger('showCourseDescriptionEllipsis')
                        $timeout(function () {
                            var courseHeaderDescriptionElement = angular.element('#course-header-description');
                            if (courseHeaderDescriptionElement[0] && (courseHeaderDescriptionElement[0].scrollWidth > courseHeaderDescriptionElement.innerWidth())) {
                                // Description has over-flowed. So show the "Show More" text
                                $scope.parentCollection.descriptionExpandable = true;
                                $scope.toggleFullDescription = function () {
                                    $scope.parentCollection.descriptionExpanded = !$scope.parentCollection.descriptionExpanded;
                                }
                            }
                        });
                    };

                    var showCourseBreadCrumbEllipsis = function(){
                        logger('showCourseBreadCrumbEllipsis')
                        $timeout(function(){
                            var collectionTitleElt = angular.element('#parent-collection-title-breadcrumb');
                            $scope.parentCollection.tooltipState = collectionTitleElt[0] && (collectionTitleElt[0].scrollWidth > collectionTitleElt.innerWidth());
                            collectionTitleElt.hover(function(){
                                $scope.parentCollection.tooltipState = collectionTitleElt[0] && (collectionTitleElt[0].scrollWidth > collectionTitleElt.innerWidth());
                                $scope.$apply();
                            });
                        });
                    };

                    $scope.$watch('activeLink', function(){
                        logger('watch activeLink')

                        if($scope.activeLink === 'pnp'){
                            showCourseBreadCrumbEllipsis();
                        }
                    });


                    $scope.$watch('render', function(){
                        logger('watch render')

                        if($scope.render){
                            $scope.showSpinner();

                            if (
                                $scope.currentCollection.cid == $scope.parentCollection.cid
                            ) {
                                getCollectionContent($scope.pagination.current);
                                CollectionService.GetCollectionTree.get({cid: $state.params.collectionId}, function (tree) {
                                    $scope.collectionTree = tree;
                                    $scope.collectionTree.show = false;
                                    $scope.currentCollection.crumbs = generateCrumbs($scope.currentCollection.cid, $scope.currentCollection.path);
                                    if($scope.currentCollection.pathLength >= 3){
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                    } else {
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                    }
                                });
                            } else {
                                if($scope.renderSource === 'Copy' || $scope.renderSource === 'Move' || $scope.renderSource === 'Delete') {
                                    $scope.renderSource = null;
                                    getCollectionContent($scope.pagination.current);
                                } else {
                                    getCollectionContent(1);
                                }

                                CollectionService.GetCollectionTree.get({cid: $state.params.collectionId}, function (tree) {
                                    $scope.collectionTree = tree;
                                    $scope.collectionTree.show = false;
                                    $scope.currentCollection.crumbs = generateCrumbs($scope.currentCollection.cid, $scope.currentCollection.path);
                                    if($scope.currentCollection.pathLength >= 3){
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                    } else {
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                    }
                                });
                            }

                            $scope.hideSpinner();
                            $scope.render = false;
                        }
                    });

                    var setContentWidthForGrid = function() {
                        logger('setContentWidthForGrid')
                        if($scope.activeView === 'grid') {
                            var divWidth = $('input.asset-title:not(.folder-title)').parent().parent().parent().parent().width() - 40;

                            //title text
                            $('div.asset-title').each(function () {
                                $(this).width(divWidth.toString() + 'px')
                            })
                        }
                    }

                    var setContentWidthForNewFolder = function() {
                        // if($scope.activeView === 'grid') {
                        //     if($('.asset-card:not(.create-folder)').length) {
                        //         var otherCardsWidth = $('.asset-card:not(.create-folder)').width();
                        //         $('.create-folder').width(otherCardsWidth);
                        //
                        //         // $('#inlineFolderCreate').width(
                        //         //     $('#inlineFolderCreate').find('.asset-card.create-folder').width()
                        //         // );
                        //
                        //         // var titleFieldWidth = $($('.asset-card:not(.create-folder)')[0]).find('input.asset-title').width();
                        //         var titleFieldWidth = '80%';
                        //         $('.create-folder input.asset-title').css('width', '');
                        //         $('.create-folder input.asset-title').width(titleFieldWidth);
                        //
                        //         var titleText = $($('.asset-card:not(.create-folder)')[0]).find('div.asset-title').width();
                        //         $('.create-folder div.folder-title').width(titleText);
                        //
                        //         $('.create-folder div.folder-title-no-hover').width(titleText);
                        //
                        //         var descriptionFieldWidth = $($('.asset-card:not(.create-folder)')[0]).find('textarea.description').width();
                        //         $('.create-folder textarea.description').width(descriptionFieldWidth);
                        //
                        //         var descriptionTextWidth = $($('.asset-card:not(.create-folder)')[0]).find('p.description').width();
                        //         $('.create-folder p.description').width(descriptionTextWidth);
                        //         $('.create-folder p.description-no-hover').width(descriptionTextWidth);
                        //         $('.create-folder p.create-folder-description-placeholder').width(descriptionTextWidth);
                        //     }
                        // }
                            //title input
                            // var divWidth = $('input.create-folder-title-grid').parent().parent().parent().parent().width() - 40;
                            // $('input.create-folder-title-grid').width(divWidth.toString() + 'px');

                            //container width

                        // }
                    }

                    var setContentWidthForList = function() {
                        logger('setContentWidthForList')
                        if($scope.activeView === 'list') {
                            if(window.innerWidth < 800) {
                                $('.pnp-item').css('width', window.innerWidth - 40 + 'px');
                                var pnpItemWidth = $('.pnp-item').width();
                                // $('.overlayimage.asset-image').width(pnpItemWidth * 0.3);


                                var imageWidth = $('.overlayimage.asset-image').width();
                                var checkboxWidth = 50;
                                var mediaIconWidth = 50;
                                var menuWidth = 38;

                                var captionWidth = pnpItemWidth - imageWidth - mediaIconWidth - checkboxWidth - menuWidth;

                                var descriptionWidth = captionWidth - 30;
                                var titleWidth = descriptionWidth - 38;

                                $('div.folder-title').css('width', titleWidth + 'px');
                                $('div.folder-title-no-hover').css('width', titleWidth + 'px');
                                $('input.folder-title').css('width', titleWidth + 'px');
                                $('div.asset-title').css('width', titleWidth + 'px');
                                $('div.asset-title-no-hover').css('width', titleWidth + 'px');
                                $('input.asset-title').css('width', titleWidth + 'px');

                                $('p.description').css('width', descriptionWidth + 'px');
                                $('p.description-no-hover').css('width', descriptionWidth + 'px');
                                $('p.create-folder-description-placeholder').css('width', descriptionWidth + 'px');
                                $('textarea.description').css('width', descriptionWidth + 'px');
                            }
                        }
                    }

                    var setCardHeight = function(itemHeight){
                        logger('setCardHeight')
                        if($scope.activeView === 'grid') {
                            $('.pnp-item.grid-group-item').each(function() {
                                if(itemHeight) {
                                    $(this).css('height', itemHeight + "px");
                                }
                            });
                        } else if ($scope.activeView === 'list') {
                            $('.pnp-item.list-group-item').each(function(item) {
                                if(itemHeight) {
                                    $(this).css('height', itemHeight + "px");
                                }
                            });
                        }
                        // calculateThumbnailDimension(assetHeight)
                    };

                    // var calculateThumbnailDimension = function(assetHeight) {
                    //     $('.grid-group-item .overlayimage').each(function() {
                    //         var maxWidth = $(this).parent.parent('.asset-card').innerWidth() - 30;
                    //         var maxHeight = assetHeight - 160,
                    //             width = (maxWidth/16 > maxHeight/9) ? (maxHeight / 9 * 16) : maxHeight,
                    //             height = width / 16 * 9;
                    //
                    //         $(this).css({
                    //             "width" : width + "px",
                    //             "height" : height + "px",
                    //             "margin-left"  : (maxWidth - width)/2,
                    //             "margin-right" : (maxWidth - width)/2
                    //         });
                    //     });
                    // };

                    // This is called for changing between the different content views
                    $scope.changeActiveView = function (view) {
                        logger('changeActiveView')
                        $scope.activeView = view;
                    };

                    $scope.isFirstCallActiveViewCall = true;
                    $scope.$watch('activeView', function() {
                        logger('watch activeView')

                        if ($scope.activeView) {
                            $('.asset-card:not(.create-folder)').css({"backgroundColor": "#FFFFFF"});

                            if ($scope.activeView === 'grid') {
                                //When first loaded, will fill allItemsCollection
                                if($scope.currentCollection) {
                                    $scope.currentCollection.contents = $scope.allItemsCollection;
                                }

                                $('.list-group.assets').hide();
                                $('.pnp-item .overlayimage').css({"width": "100%", "margin-bottom": "2%"});

                                var newCFTitle = $('.create-folder-title-list').val();
                                var newCFDescription = $('.create-folder-description-list').val();
                                var newCFDataXid = $('.create-folder-description-list').parents('[data-xid]').attr('data-xid');

                                setTimeout(function() {
                                    if(newCFDescription && newCFDescription.trim().length) {
                                        $('.create-folder-title-grid').parent().children('div.folder-title-no-hover').hide();
                                        $('.create-folder-title-grid').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                        $('.create-folder-title-grid').parent().find('div.folder-title').hide();
                                        $('.create-folder-title-grid').parent().find('div.folder-title').text(newCFTitle);
                                        $('.create-folder-title-grid').parent().find('input.folder-title').hide();
                                        $('.create-folder-title-grid').parent().find('input.folder-title').val(newCFTitle);
                                        $('.create-folder-title-grid').parent().find('div.folder-title').show();

                                        $('.create-folder-description-grid').parent().parent().parent().parent().attr('data-xid', newCFDataXid);
                                        $('.create-folder-description-grid').parent().children('p.description').hide();
                                        $('.create-folder-description-grid').parent().children('p.description-no-hover').hide();
                                        $('.create-folder-description-grid').parent().children('p.create-folder-description-placeholder').hide();
                                        $('.create-folder-description-grid').val(newCFDescription);
                                        $('.create-folder-description-grid').show();
                                        $('.create-folder-description-grid').scrollTop(0);
                                        $('.create-folder-description-grid').focus();
                                    } else if(newCFTitle && newCFTitle.trim().length) {
                                        if($scope.hasFocusInCFDescription) {
                                            $('.create-folder-description-grid').parents('.asset-card').attr('data-xid', newCFDataXid);
                                            $('.create-folder-title-grid').parent().find('input.folder-title').hide();
                                            $('.create-folder-title-grid').parent().find('input.folder-title').val(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('div.folder-title-no-hover').hide();
                                            $('.create-folder-title-grid').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('div.folder-title').text(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('div.folder-title').show();

                                            $('.create-folder-title-grid').parent().parent().find('p.description').hide();
                                            $('.create-folder-title-grid').parent().parent().find('p.description-no-hover').hide();
                                            $('.create-folder-title-grid').parent().parent().find('p.create-folder-description-placeholder').hide();
                                            $('.create-folder-title-grid').parent().parent().find('textarea.description').show();
                                            $('.create-folder-title-grid').parent().parent().find('textarea.description').focus();
                                        } else {
                                            $('.create-folder-description-grid').parents('.asset-card').attr('data-xid', newCFDataXid);
                                            $('.create-folder-title-grid').parent().children('div.folder-title-no-hover').hide();
                                            $('.create-folder-title-grid').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('div.folder-title').hide();
                                            $('.create-folder-title-grid').parent().find('div.folder-title').text(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('input.folder-title').val(newCFTitle);
                                            $('.create-folder-title-grid').parent().find('input.folder-title').show();
                                            $('.create-folder-title-grid').parent().find('input.folder-title').focus();
                                        }
                                    }
                                }, 100);

                                $('#inlineFolderCreate').height(360);

                                $('.assets').css('opacity', '0');


                            } else if ($scope.activeView === 'list') {
                                $scope.currentCollection.contents = $scope.allItemsCollection.slice(0, 8);

                                $('.pnp-item .overlayimage').css({"height" : "130px", "width" : "25%", margin: 0});

                                var newCFTitle = $('.create-folder-title-grid').val();
                                var newCFDescription = $('.create-folder-description-grid').val();
                                var newCFDataXid = $('.create-folder-description-grid').parents('[data-xid]').attr('data-xid');

                                setTimeout(function() {
                                    if(newCFDescription && newCFDescription.trim().length) {
                                        $('.create-folder-title-list').parent().children('div.folder-title-no-hover').hide();
                                        $('.create-folder-title-list').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                        $('.create-folder-title-list').parent().find('div.folder-title').hide();
                                        $('.create-folder-title-list').parent().find('div.folder-title').text(newCFTitle);
                                        $('.create-folder-title-list').parent().find('input.folder-title').hide();
                                        $('.create-folder-title-list').parent().find('input.folder-title').val(newCFTitle);
                                        $('.create-folder-title-list').parent().find('div.folder-title').show();

                                        $('.create-folder-description-list').parents('.asset-card').attr('data-xid', newCFDataXid);
                                        $('.create-folder-description-list').parent().children('p.description').hide();
                                        $('.create-folder-description-list').parent().children('p.description-no-hover').hide();
                                        $('.create-folder-description-list').parent().children('p.create-folder-description-placeholder').hide();
                                        $('.create-folder-description-list').val(newCFDescription);
                                        $('.create-folder-description-list').show();
                                        $('.create-folder-description-list').scrollTop(0);
                                        $('.create-folder-description-list').focus();
                                    } else if(newCFTitle && newCFTitle.trim().length) {
                                        if($scope.hasFocusInCFDescription) {
                                            $('.create-folder-description-list').parents('.asset-card').attr('data-xid', newCFDataXid);
                                            $('.create-folder-title-list').parent().find('input.folder-title').hide();
                                            $('.create-folder-title-list').parent().find('input.folder-title').val(newCFTitle);
                                            $('.create-folder-title-list').parent().find('div.folder-title-no-hover').hide();
                                            $('.create-folder-title-list').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                            $('.create-folder-title-list').parent().find('div.folder-title').text(newCFTitle);
                                            $('.create-folder-title-list').parent().find('div.folder-title').show();

                                            $('.create-folder-title-list').parent().parent().find('p.description').hide();
                                            $('.create-folder-title-list').parent().parent().find('p.description-no-hover').hide();
                                            $('.create-folder-title-list').parent().parent().find('p.create-folder-description-placeholder').hide();
                                            $('.create-folder-title-list').parent().parent().find('textarea.description').show();
                                            $('.create-folder-title-list').parent().parent().find('textarea.description').focus();
                                        } else {
                                            $('.create-folder-description-list').parents('.asset-card').attr('data-xid', newCFDataXid);
                                            $('.create-folder-title-list').parent().children('div.folder-title-no-hover').hide();
                                            $('.create-folder-title-list').parent().find('div.folder-title-no-hover').text(newCFTitle);
                                            $('.create-folder-title-list').parent().find('div.folder-title').hide();
                                            $('.create-folder-title-list').parent().find('div.folder-title').text(newCFTitle);
                                            $('.create-folder-title-list').parent().find('input.folder-title').val(newCFTitle);
                                            $('.create-folder-title-list').parent().find('input.folder-title').show();
                                            $('.create-folder-title-list').parent().find('input.folder-title').focus();
                                        }
                                    }
                                }, 100)

                                $('#inlineFolderCreate').height(174);
                            }

                            $('.assets').show();

                            if($scope.activeView === 'grid') {
                                if (
                                    $('#inlineFolderCreate').is(':visible') &&
                                    $scope.currentCollection &&
                                    $scope.currentCollection.contents
                                ) {
                                    var cfWidth = $($('.item.pnp-item .asset-card')[1]).innerWidth() - 10;
                                    $('#inlineFolderCreate').outerWidth(cfWidth);
                                    $('#inlineFolderCreate .asset-card').outerWidth(cfWidth);

                                    if($scope.rowsToShow === 3 && $scope.currentCollection.contents.length === 12) {
                                        $('.item.pnp-item').last().hide();
                                    }

                                    if($scope.rowsToShow === 2 && $scope.currentCollection.contents.length === 8) {
                                        $('.item.pnp-item').last().hide();
                                    }

                                    if($scope.rowsToShow === 1 && $scope.currentCollection.contents.length === 4) {
                                        $('.item.pnp-item').last().hide();
                                    }
                                }
                            }

                            if(!$scope.isFirstCallActiveViewCall) {
                                makeContentResponsive('changeView');
                            }

                            setTimeout(function() {
                                // $('.list-group.assets').show();
                                $scope.manageCheckAllState();
                            }, 0)

                            $scope.isFirstCallActiveViewCall = false;
                        }
                    });

                    $scope.toggleFilterAndSort = function () {
                        logger('toggleFilterAndSort')
                        $scope.showFilterAndSort = !$scope.showFilterAndSort;
                    };

                    $scope.toggleFilter = function (filter) {
                        logger('toggleFilter')
                        filter.selected = !filter.selected;
                    };

                    $scope.toggleSearch = function () {
                        logger('toggleSearch')
                        $scope.search.activateSearch = !$scope.search.activateSearch;
                        if (!$scope.search.activateSearch) {
                            $scope.search.query = "";
                            $scope.showSearchResults = false;
                        }
                        $timeout(function(){
                            if($scope.search.activateSearch){
                                $('#searchbox').focus();
                            }
                        })
                    };

                    $scope.setActiveSort = function (sort) {
                        logger('setActiveSort')
                        $scope.activeSortId = $scope.activeSortId === sort.id ? "" : sort.id;
                    };

                    $scope.resetFilterAndSort = function () {
                        logger('resetFilterAndSort')
                        angular.forEach($scope.filters, function (filter) {
                            filter.selected = false;
                        });
                        $scope.activeSortId = "publishedDate";
                        $scope.filterAndSortText = "Filter / Sort";
                        $scope.filterApplied = false;
                    };

                    $scope.clearFilterAndSort = function (event) {
                        logger('clearFilterAndSort')
                        event.stopPropagation();
                        $scope.resetFilterAndSort();
                        $scope.applyFilterAndSort();
                    };

                    $scope.applyFilterAndSort = function () {
                        logger('applyFilterAndSort')
                        $scope.pagination.current = 1;
                        getCollectionContent(1);
                        var selectedFilters = $filter('filter')($scope.filters, {selected: true}, true),
                            selectedSort = $filter('filter')($scope.sorts, {id: $scope.activeSortId}, true);
                        if (selectedFilters.length || selectedSort.length) {
                            var selectedSortName = selectedSort.length ? selectedSort[0].name : "N/A";
                            $scope.filterAndSortText = "<b>" + selectedFilters.length + " Filters </b> / Sort By <b>" + selectedSortName + "</b>";
                        } else {
                            $scope.filterAndSortText = "Filter / Sort";
                        }
                        if (selectedFilters.length) {
                            $scope.filterApplied = true;
                        }
                        $scope.showFilterAndSort = false;
                    };

                    $scope.findContent = function () {
                        logger('findContent')

                        var query = $scope.search.query;
                        if(query) {
                            SearchService.SearchAssets.get({
                                query: query,
                                sitewide: false,
                                cid: $scope.parentCollection.cid,
                                limit: 200,
                                offset: 0
                            }, function (contentList) {
                                var collectionIdList = [],
                                    searchResults = [];

                                angular.forEach(contentList.contents, function (result) {
                                    var parent = result.parent;
                                    if (collectionIdList.indexOf(parent.cid) === -1) {
                                        parent.crumbs = generateCrumbs(parent.cid, parent.path);
                                        collectionIdList.push(parent.cid);
                                        searchResults.push({
                                            parent: parent,
                                            pathLength: parent.path.split('/').length,
                                            hits: $filter('filter')(contentList.contents, {parent: {cid: parent.cid}}, true)
                                        });
                                    }
                                });

                                $scope.searchResults = {
                                    searchTerm: query,
                                    hits: searchResults,
                                    totalHits: contentList.contents.length
                                };
                                $scope.showSearchResults = true;
                            });
                        } else {
                            $scope.showSearchResults = false;
                        }
                    };

                    var modalConfirm = function(callback){
                        logger('modalConfirm')
                          $("#delete-item").on("click", function(){
                            callback(true);
                            $("#delete-modal").modal('hide');
                          });

                          $("#modal-btn-close").on("click", function(){
                            $("#delete-modal").modal('hide');
                          });
                    };

                    modalConfirm(function(confirm){
                      if(confirm){
                        $scope.deleteItem();
                      }else{
                      }
                    });

                    $scope.confirmDeleteItem = function () {
                        logger('confirmDeleteItem')
                        $("#delete-modal").modal('show');
                        var checked = $('.item-checkbox:checked');
                        if (checked.length > 2) {
                            $('#delete-modal #myModalLabel').text('Delete Items (' + checked.length + ')?');
                            $('#delete-modal .modal-body p').text('Selecting “Delete” will delete these items as well as any items stored in them. This action cannot be undone.');
                            $("#delete-modal").modal('show');
                        }
                        else if (checked.length === 1){
                            var xid = $(checked[0]).parent().parent().parent().parent().parent().data('xid');
                            if ($scope.activeView === 'list') {
                                xid = $(checked[0]).parent().parent().parent().parent().data('xid');
                            }
                            var content = $scope.currentCollection.contents.find((el) => el.xid === xid);
                            console.log('content: ', content)
                            if (content) {
                                var title = content.title;
                                var isCollection = content.type === "Collection";
                                var text = isCollection ? 'Deleting the “' + title + '” Folder will delete the Folder as well as any items stored in it. This action cannot be undone.' : 'This action cannot be undone.';
                                $('#delete-modal #myModalLabel').text(isCollection ? 'Delete Folder?' : 'Delete Media Asset?');
                                $('#delete-modal .modal-body p').text(text);
                            }
                        }
                        else if (checked.length === 2){
                            var nameArr = ['', 'and', ''];
                            var first = $(checked[0]).parent().parent().parent().parent().parent().data('xid');
                            var second = $(checked[1]).parent().parent().parent().parent().parent().data('xid');
                            if ($scope.activeView === 'list') {
                                first = $(checked[0]).parent().parent().parent().parent().data('xid');
                                second = $(checked[1]).parent().parent().parent().parent().data('xid');
                            }
                            var firstName = '"' + $scope.currentCollection.contents.find((el) => el.xid === first).title + '"';
                            var secondName = '"' + $scope.currentCollection.contents.find((el) => el.xid === second).title + '"';
                            $('#delete-modal #myModalLabel').text('Delete Items (2)?');
                            $('#delete-modal .modal-body p').text(firstName + ' and ' + secondName + ', as well as any items stored in them, will be deleted.  This action cannot be undone.');
                        }
                        else {
                            return;
                        }
                    }

                    $scope.deleteItem = function () {
                        logger('confirmDeleteItem')
                        var xids = [];
                        if ($scope.activeView === 'list') {
                              $.each($('.item-checkbox:checked'), function(k,v) {
                                  console.log($(v))
                                  xids.push($(v).parent().parent().parent().parent().data('xid'));
                              });
                        }
                        else {
                            $.each($('.item-checkbox:checked'), function(k,v) {
                                console.log($(v))
                                xids.push($(v).parent().parent().parent().parent().parent().data('xid'));
                            });
                        }

                        var items = [];
                        var filteredArray = $scope.currentCollection.contents.filter((el) => {
                          return xids.some((f) => {
                            return f === el.xid;
                          });
                        });
                        $.each(filteredArray, function(k, file) {
                            var item = {};
                            item.collectionContentDTO = file;
                            item.destinationCollectionId = $scope.currentCollection.cid;
                            items.push(item);
                        });

                        console.log('Operation: Delete');
                        console.log('Items: ', items);
                        console.log('Items Length: ', items.length);

                        var deleteItem = new BaseFileService.DeleteItem({
                           contents: items,
                           totalContents: items.length
                        });
                        deleteItem.$save(function (response) {
                            console.log('deleteItem resp: ', response);
                            $scope.renderSource = 'Delete'
                            $scope.render = true;

                            $('#selectAllCheck span').removeClass('selectAllCheckboxIndeterminate'); //removes IS icon
                            $('#selectAllCheck input').attr('checked', false);
                            $('#selectAllCheck input').addClass('custom-checkbox');
                        }, function () {
                        });
                    }

                    $scope.showSpinner = function () {
                        logger('showSpinner')
                        $('.overlay-main').css('width', '100%');
                        $('.overlay-main').css('height', '100%');
                        $('.overlay-main').show();
                    };

                    $scope.hideSpinner = function () {
                        logger('hideSpinner')
                        $('.overlay-main').css('width', '0%');
                        $('.overlay-main').css('height', '0%');
                        $('.overlay-main').hide();
                    };

                    $scope.showCreateFolder = function () {
                        logger('showCreateFolder')
                        $scope.showSpinner();
                        $('.new-folder-checkbox').attr('checked', false);
                        $scope.pagination.current = 1;
                        $scope.getCollectionContent(1);
                        $timeout(function () {
                            $scope.currentCollection.createdFolder = null;
                            var count = 1;
                            // $.each($scope.currentCollection.contents, function (k, v) {
                            $.each($scope.currentCollection.childCollections, function (k, v) {
                                if (v.title.includes('Untitled Folder')) {
                                    count++;
                                }
                            });
                            // var num = pad(count);
                            var num = count;
                            var untitled = num != '01' ? 'Untitled Folder ' + num : 'Untitled Folder';
                            var createFolder = new CollectionService.CreateCollection({
                                title: untitled,
                                type: 'C',
                                contributor: $scope.account.login,
                                description: '',
                                lmsCourseId: '',
                                active: '1',
                                lockContentOrder: 0,
                                parentCollectionId: $scope.currentCollection.cid,
                            });
                            createFolder.$save(function (response) {
                                console.log('createFolder resp: ', response);

                                //TODO: think of edge cases. Ex: User deletes, copies or moves card while in CF mode
                                //Solution #1: hide or show last card everytime a change happens in the current collection
                                if($('.asset-card').length > 8) {
                                    $('.item.pnp-item').last().hide();
                                } else {
                                    $('.item.pnp-item').last().show();
                                }

                                if($scope.activeView === 'grid') {
                                    $('#inlineFolderCreate').height(360);
                                } else if($scope.activeView === 'list') {
                                    $('#inlineFolderCreate').height(174);
                                }

                                $('#inlineFolderCreate').show();

                                if($scope.isLMSCourse) {
                                    //Get any existing card's width and apply to #inlineFolderCreate
                                    if ($('.asset-card').length > 1) {
                                        var cardWidth = $($('.asset-card')[1]).css('width');
                                        cardWidth = parseInt(cardWidth.replace('px', ''));

                                        $('#inlineFolderCreate').width(cardWidth - 4);
                                    }

                                    $('.asset-card.create-folder').width('');
                                }
                                $('#inlineFolderCreate .asset-card').attr('data-xid', response.result);

                                var collectionObj = { title: '', description: '', xid: response.result, type: 'Collection' };
                                $scope.currentCollection.totalContents = $scope.currentCollection.totalContents + 1;
                                $scope.currentCollection.createdFolder = collectionObj;
                                $scope.parentCollection.childCollections.push(collectionObj);
                                $scope.copyWizardAvailable = false;
                                $scope.hideSpinner();

                                //focus on text input
                                if($scope.activeView === 'grid') {
                                    $('.create-folder-title-grid').parent().children('.folder-title').text('');
                                    $('.create-folder-title-grid').parent().children('.folder-title-no-hover').text('');
                                    $('.create-folder-title-grid').parent().children('.folder-title').hide();
                                    $('.create-folder-title-grid').parent().children('.folder-title-no-hover').hide();
                                    $('.create-folder-title-grid').val('');
                                    $('.create-folder-title-grid').show();

                                    var idTimeout = setTimeout(function(){
                                        if ($('#inlineFolderCreate').is(':visible')) {
                                            $('.create-folder-title-grid').focus();
                                            clearTimeout(idTimeout);
                                        }
                                    }, 100);

                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('p').val('');
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('p').text('');
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('p').hide();
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('textarea').hide();
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('textarea').val('');
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('.create-folder-description-placeholder').text('Enter a description');
                                    $($('.create-folder-title-grid').parent().parent().children()[1]).children('.create-folder-description-placeholder').show();
                                } else if ($scope.activeView === 'list') {
                                     $('.create-folder-title-list').parent().children('.folder-title').text('');
                                     $('.create-folder-title-list').parent().children('.folder-title-no-hover').text('');
                                     $('.create-folder-title-list').parent().children('.folder-title').hide();
                                     $('.create-folder-title-list').parent().children('.folder-title-no-hover').hide();
                                     $('.create-folder-title-list').val('');
                                     $('.create-folder-title-list').show();

                                     var idTimeout = setTimeout(function(){
                                        if ($('#inlineFolderCreate').is(':visible')) {
                                            $('.create-folder-title-list').focus();
                                            clearTimeout(idTimeout);
                                        }
                                    }, 100);

                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('p').val('');
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('p').text('');
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('p').hide();
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('textarea').hide();
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('textarea').val('');
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('.create-folder-description-placeholder').text('Enter a description');
                                    $($('.create-folder-title-list').parent().parent().children()[1]).children('.create-folder-description-placeholder').show();
                                }

                                $scope.loadComponent('pnp');
                            }, function () {
                            });
                        }, 1000);
                    };

                    // For accessible modals
                    var modalFocus = function (first, last) {
                        logger('modalFocus')
                        var firstItem = $(first),
                            lastItem = $(last);

                        /*set focus on first item*/
                        firstItem.focus();

                        /*redirect last tab to first input*/
                        lastItem.on('keydown', function (e) {
                            if ((e.which === 9 && !e.shiftKey)) {
                                e.preventDefault();
                                firstItem.focus();
                            }
                        });

                        /*redirect first shift+tab to last input*/
                        firstItem.on('keydown', function (e) {
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                lastItem.focus();
                            }
                        });
                    };

                    function pad(d) {
                        return (d < 10) ? '0' + d.toString() : d.toString();
                    }

                    $scope.updateItem = function (xid) {
                        logger('updateItem')
                        var itemToUpdate = $scope.currentCollection.createdFolder;
                        var titleField = $('div[data-xid="' + xid + '"] input.asset-title');

                        ////Getting the last time we used Untitled Folder, get its number and give it the next
                        var untitledFolderLength = 'Untitled Folder'.length;
                        var nextUntitledFolderNumber;
                        var fullListFolderNumber;
                        var currentPageFolderNumber;

                        //Get next Untitled Folder number from full list (not updated after updating the list)
                        var newestUntitledFolder = $scope.currentCollection.childCollections.reverse().find(p => p.title.includes('Untitled Folder'));
                        if(newestUntitledFolder) {
                            if(newestUntitledFolder.title.length > untitledFolderLength) {
                                try {
                                    fullListFolderNumber = parseInt(newestUntitledFolder.title.substring(untitledFolderLength));
                                } catch(e) {
                                    fullListFolderNumber = 1;
                                }
                            } else {
                                fullListFolderNumber = 1;
                            }
                        } else {
                            fullListFolderNumber = 0;
                        }

                        //Get next Untitled Folder number from current page
                        var currentPageNewestFolder = $scope.currentCollection.contents.find(p => p.title.includes('Untitled Folder'));
                        if(currentPageNewestFolder) {
                            if(currentPageNewestFolder.title.length > untitledFolderLength) {
                                try {
                                    currentPageFolderNumber = parseInt(currentPageNewestFolder.title.substring(untitledFolderLength));
                                } catch(e) {
                                    currentPageFolderNumber = 1;
                                }
                            } else {
                                currentPageFolderNumber = 1;
                            }
                        } else {
                            currentPageFolderNumber = 0;
                        }

                        //Compare current page with full list
                        if(fullListFolderNumber > currentPageFolderNumber) {
                            nextUntitledFolderNumber = fullListFolderNumber + 1;
                        } else if(currentPageFolderNumber > 1) {
                            nextUntitledFolderNumber = currentPageFolderNumber + 1;
                        } else if (currentPageFolderNumber === 0 && fullListFolderNumber === 0) {
                            nextUntitledFolderNumber = 1;
                        } else if (currentPageFolderNumber === 1 || fullListFolderNumber === 1) {
                            nextUntitledFolderNumber = 2;
                        }

                        var untitled = nextUntitledFolderNumber != '1' ? 'Untitled Folder ' + nextUntitledFolderNumber : 'Untitled Folder';

                        if (titleField.val() && titleField.val().trim().length) {
                            itemToUpdate.title = titleField.val().trim();
                        }
                        else {
                            itemToUpdate.title = untitled;
                            $('div[data-xid="' + xid + '"] .asset-title').val(untitled)
                        }

                        var descriptionField = $('div[data-xid="' + xid + '"] textarea');
                        if(descriptionField.val()) {
                            itemToUpdate.description = descriptionField.val().trim();
                        } else {
                            itemToUpdate.description = '';
                        }

                        var updateItem = new BaseFileService.UpdateItem({
                            collectionContentDTO: itemToUpdate,
                            destinationCollectionId: $scope.currentCollection.cid,
                        });
                        updateItem.$save(function (response) {
                            console.log('updateItem resp: ', response);
                            }, function () {
                        });
                    }

                    $('#folderTitleDivList').blur(function(e, t) {
                        logger('folderTitleDivList blur')
                        // trap the return key being pressed
                        var updatedXid = $(this).parent().parent().parent().data('xid');
                        $scope.updateItem(updatedXid);
                        return false;
                    });

                    $('#folderDescriptionPList').blur(function(e) {
                        logger('folderDescriptionPList blur')
                        // trap the return key being pressed
                        var updatedXid = $(this).parent().parent().data('xid');
                        $scope.updateItem(updatedXid);
                        return false;
                    });

                    $scope.isPersistingTitle = false;

                    $scope.handleInputTitleKeyPress = function(e) {
                        logger('handleInputTitleKeyPress')
                        if(e.keyCode === 13) {
                            $scope.persistTitle({titleField: e.target, shouldRefreshContent: false, shouldFocusOnDescription: true});
                        }
                    }

                    $scope.handleInputTitleBlur = function(e) {
                        $scope.persistTitle({titleField: e.target, shouldFocusOnDescription: true});
                    }

                    $scope.manageCheckAllState = function(e) {
                        logger('manageCheckAllState');

                        var checkboxList = document.querySelectorAll('.asset-card .custom-checkbox:not(.new-folder-checkbox)');
                        var checkAllCheckbox = document.querySelector('#selectAllCheck input');
                        var checkAllSpan = document.querySelector('#selectAllCheck span');
                        var items = document.querySelectorAll('.pnp-item:not(#inlineFolderCreate)');
                        var allChecked = true;
                        var uncheckedCount = 0;

                        for(let checkbox of checkboxList) {
                            if (!checkbox.checked) {
                                allChecked = false;
                                uncheckedCount++;
                            }
                        }

                        if(checkAllCheckbox && checkAllSpan) {
                            //all selected
                            if(allChecked) {
                                checkAllCheckbox.checked = true;
                                checkAllSpan.classList.remove('selectAllCheckboxIndeterminate');
                                checkAllCheckbox.classList.add('custom-checkbox');
                            }

                            //some selected
                            if(!allChecked && uncheckedCount < checkboxList.length && uncheckedCount > 0) {
                                // checkAllCheckbox.checked = true;
                                checkAllSpan.classList.add('selectAllCheckboxIndeterminate');
                                checkAllCheckbox.classList.remove('custom-checkbox');
                                checkAllCheckbox.style.display = 'none';
                            }

                            //none selected
                            if(uncheckedCount === checkboxList.length) {
                                checkAllSpan.classList.remove('selectAllCheckboxIndeterminate');
                                checkAllCheckbox.classList.add('custom-checkbox');
                                checkAllCheckbox.checked = false;
                            }
                        }
                    }

                    var selectedCheckboxes = [];
                    var saveSelectedCheckboxes = function() {
                        logger('saveSelectedCheckboxes')
                        selectedCheckboxes = []

                        $('.asset-card:not(.create-folder) input[type="checkbox"]').each((index, item) => {
                            if( $(item)[0].checked ) {
                                selectedCheckboxes.push(index);
                            }
                        });

                        //If the Select All checkbox is selected, we call it -1
                        if( $('#selectAllCheck input')[0].checked ) {
                            selectedCheckboxes.push(-1);
                        }
                    }

                    var selectCheckboxes = function() {
                        logger('selectCheckboxes')

                        for(var i = 0; i < selectedCheckboxes.length; i++) {
                            if(selectedCheckboxes[i] === -1) {
                                setTimeout(() => {
                                    $('#selectAllCheck input')[0].click();
                                }, 100)
                            }

                            if (selectedCheckboxes[i] > -1) {
                                if($('.asset-card:not(.create-folder) input[type="checkbox"]')[selectedCheckboxes[i] + 1]) {
                                    $('.asset-card:not(.create-folder) input[type="checkbox"]')[selectedCheckboxes[i] + 1].checked = true;
                                }
                            }
                        }

                        $scope.manageCheckAllState();

                        if($('#selectAllCheck')[0].checked) {
                            $('.asset-card:not(.create-folder) input[type="checkbox"]')[0].checked = true;
                        }

                        $scope.setSelectedItemsBgColor();
                    }

                    $scope.setSelectedItemsBgColor = function() {
                        logger('setSelectedItemsBgColor')

                        $('.asset-card input[type="checkbox"]').each((index, item) => {
                            var container;
                            if($scope.activeView === 'grid') {
                                container = $(item).parent().parent().parent().parent().parent()[0];
                            } else if ($scope.activeView === 'list') {
                                container = $(item).parent().parent().parent().parent()[0];
                            }

                            if(container) {
                                if($(item)[0].checked) {
                                    container.style.backgroundColor = $scope.cardBgColorOnFocus;
                                } else {
                                    if(container.childNodes && container.childNodes.length && container.childNodes.classList) {
                                        if(!container.childNodes[0].classList.contains('create-folder')) {
                                            container.style.backgroundColor = "#FFFFFF";
                                        }
                                    }
                                }
                            }
                        })
                    }

                    /**
                     * params: {
                     *     titleField,
                     *     shouldRefreshContent,
                     *     shouldFocusOnDescription
                     * }
                     * */
                    $scope.persistTitle = function(params) {
                        logger('persistTitle')
                        $scope.isPersistingTitle = true;

                        try {
                            var updatedXid = $(params.titleField).parents('[data-xid]').attr('data-xid');
                            $scope.updateItem(updatedXid);

                            //TODO: save selected checkboxes
                            saveSelectedCheckboxes();

                            if (params.shouldRefreshContent) {
                                //It needs to wait for the content to be saved.
                                setTimeout(function(){
                                    $scope.getCollectionContent($scope.pagination.current);
                                    CollectionService.GetCollectionTree.get({cid: $state.params.collectionId}, function (tree) {
                                        $scope.collectionTree = tree;
                                        $scope.collectionTree.show = false;
                                        $scope.currentCollection.crumbs = generateCrumbs($scope.currentCollection.cid, $scope.currentCollection.path);
                                        if($scope.currentCollection.pathLength >= 3){
                                            $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                        } else {
                                            $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                        }

                                        selectCheckboxes();
                                        $scope.manageCheckAllState();
                                    });

                                    $('.assets').children().last().show();

                                    // //TODO: select checkboxes again
                                    // selectCheckboxes();
                                }, 1000)
                            }
                        } finally {
                            $(params.titleField).hide();
                            $(params.titleField).parent().find('.folder-title').text($(params.titleField).val())
                            $(params.titleField).parent().find('.folder-title').hide();
                            $(params.titleField).parent().find('.folder-title-no-hover');
                            $(params.titleField).parent().find('.folder-title-no-hover').text($(params.titleField).val());
                            $(params.titleField).parent().find('.folder-title-no-hover').removeClass('ng-hide');
                            $(params.titleField).parent().find('.folder-title-no-hover').show();

                            if(params.shouldFocusOnDescription) {
                                $(params.titleField).parent().parent().find('.create-folder-description-placeholder').hide();
                                $(params.titleField).parent().parent().find('p.description').hide();
                                $(params.titleField).parent().parent().find('p.description-no-hover').hide();
                                $(params.titleField).parent().parent().find('textarea.description').show();
                                $(params.titleField).parent().parent().find('textarea.description').focus();
                            }
                        }

                        setTimeout(function() {
                            $scope.isPersistingTitle = false;
                        }, 1000)


                        // trap the return key being pressed
                        return false;
                    }

                    $scope.handleDescriptionTextareaKeyPress = function(e) {
                        if(e.keyCode === 13) {
                            $scope.persistDescription(e.target);
                        }
                    }

                    $scope.isPersistingDescription = false;
                    $scope.persistDescription = function(descriptionField) {
                        logger('persistDescription')

                        $scope.isPersistingDescription = true;
                        try {
                            var updatedXid = descriptionField.parentElement.parentElement.parentElement.parentElement.getAttribute('data-xid');
                            $scope.updateItem(updatedXid);
                            setTimeout(function() {
                                $scope.getCollectionContent($scope.pagination.current);
                                CollectionService.GetCollectionTree.get({cid: $state.params.collectionId}, function (tree) {
                                    $scope.collectionTree = tree;
                                    $scope.collectionTree.show = false;
                                    $scope.currentCollection.crumbs = generateCrumbs($scope.currentCollection.cid, $scope.currentCollection.path);
                                    if($scope.currentCollection.pathLength >= 3){
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                    } else {
                                        $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                    }
                                });

                                $('.assets').children().last().show();
                            }, 500);
                        } finally {
                            var descriptionText = descriptionField.parentElement.querySelector('p.description');
                            var descriptionNoHoverText = descriptionField.parentElement.querySelector('p.description-no-hover');

                            //fill p hover
                            descriptionText.innerText = descriptionField.value;

                            //fill p no hover
                            descriptionNoHoverText.innerText = descriptionField.value;

                            //hide description hover
                            descriptionText.style.display = 'none';

                            //hide description textarea
                            descriptionField.style.display = 'none';
                            descriptionField.style.background = '#FFFFFF';

                            //display description no hover
                            descriptionNoHoverText.classList.remove('ng-hide');
                            descriptionNoHoverText.style.display = '';
                        }

                        setTimeout(function() {
                            $scope.isPersistingDescription = false;
                        }, 1000)
                    }

                    $('#folderDescriptionPGrid').blur(function(e) {
                        logger('folderDescriptionPGrid blur')
                        // trap the return key being pressed
                        var updatedXid = $(this).parent().parent().data('xid');
                        $scope.updateItem(updatedXid);
                        return false;
                    });

                    $('div[contenteditable]').keydown(function(e) {
                        // trap the return key being pressed
                        if (e.keyCode === 13 || e.keyCode === 9) {
                            $('div[contenteditable]').blur('test');
                            var updatedXid = $(this).parent().parent().parent().data('xid');
                            $scope.updateItem(updatedXid);
                            return false;
                        }
                    });

                    $('p[contenteditable]').keydown(function(e) {
                        // trap the return key being pressed
                        if (e.keyCode === 13 || e.keyCode === 9) {
                            $('p[contenteditable]').blur();
                            var updatedXid = $(this).parent().parent().data('xid');
                            $scope.updateItem(updatedXid);
                            return false;
                        }
                    });

                    $scope.openModal = function (type) {
                        logger('openModal')
                        var xids = [];
                        var contents = $scope.currentCollection.contents;
                        if ($scope.showSearchResults) {
                            contents = [];
                            $.each($scope.searchResults.hits, function (h,j) {
                                $.each($('.item-checkbox:checked'), function(k,v) {
                                      console.log($(v));
                                      var cid = $(v).parent().parent().parent().parent().parent().data('cid');
                                      if (cid === j.parent.cid) {
                                            xids.push($(v).parent().parent().parent().parent().data('xid'));
                                            contents.push(...j.hits);
                                      }
                                });
                            });
                        }
                        else {
                            if ($scope.activeView === 'list') {
                                  $.each($('.item-checkbox:checked'), function(k,v) {
                                      console.log($(v))
                                      xids.push($(v).parent().parent().parent().parent().data('xid'));
                                  });
                            }
                            else {
                                $.each($('.item-checkbox:checked'), function(k,v) {
                                    console.log($(v))
                                    xids.push($(v).parent().parent().parent().parent().parent().data('xid'));
                                });
                            }
                        }

                        var filteredArray = contents.filter((el) => {
                          return xids.some((f) => {
                            return f === el.xid;
                          });
                        });
                        console.log('filtered items: ', filteredArray);
                        $scope.content = {
                            type: type,
                            item: filteredArray,
                        };
                        $("#itemManagementWindow").modal('show')
                        .on('shown.bs.modal', function () {
                            modalFocus('#publishHeading', '#returnTopublishHeading');
                            $('#returnTopublishHeading').on('focus', function () {
                                $('#publishHeading').focus()
                            });
                        });
                    };

                    $scope.checkForEnterKey = function (event, action) {
                        console.log('checkForEnterKey')
                        if (event.keyCode === 13) {
                            switch(action){
                                case "search":
                                    $scope.findContent();
                                    break;
                                case "collectionTree":
                                    $('#folder-popover-trigger').popover('toggle');
                                    $('.folder-popover').css('left', 0);
                                    $('.folder-popover .arrow').css('left', '58px');
                                    break;
                                case "settingsLaunch":
                                    $scope.loadComponent('settings');
                                    break;
                                case "pnpLaunch":
                                    $scope.getParent();
                                    break;
                                case "mediaInboxLaunch":
                                    $scope.loadComponent('mediainbox');
                                    break;
                                case "zoomImportLaunch":
                                    $scope.loadComponent('zoomimport');
                                    break;
                                case "zoomRecordingLaunch":
                                    $scope.loadComponent('zoomrecording');
                                    break;
                                case "schedulerLaunch":
                                    $scope.loadComponent('scheduler');
                                    break;
                                case "resetFilterAndSort":
                                    $scope.resetFilterAndSort();
                                    break;
                                case "applyFilterAndSort":
                                    $scope.applyFilterAndSort();
                            }
                        }
                    };

                    $scope.loadComponent = function (component) {
                        $('.empty-wrapper').show();
                        logger('loadComponent');
                        $scope.activeLink = component;
                    };

                    function getParameterByName(name, url) {
                        if (!url) url = window.location.href;
                        name = name.replace(/[\[\]]/g, '\\$&');
                        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                            results = regex.exec(url);
                        if (!results) return null;
                        if (!results[2]) return '';
                        return decodeURIComponent(results[2].replace(/\+/g, ' '));
                    }

                    var atmosphereSetup = function () {
                        logger('atmosphereSetup')
                        var request = {
                            url: './notification/inbox/' + $state.params.collectionId,
                            contentType: 'application/json',
                            logLevel: 'debug',
                            transport: 'websocket',
                            fallbackTransport: 'streaming',
                            trackMessageLength: true,
                            reconnectInterval: 5000,
                            enableXDR: true,
                            timeout: 300000,
                            shared: true
                        };

                        request.onOpen = function(response) {
                            console.log('Atmosphere connected using ' + response.transport);
                        };

                        request.onMessage = function (response) {
                            try{
                                var message = JSON.parse(response.responseBody);
                                if (message.parentCollectionId === $state.params.collectionId && message.newSubmissions) {
                                    $scope.submissions.new = message.newSubmissions;
                                }
                            }catch(err) {
                                console.log(err.message);
                            }
                        };

                        request.onClientTimeout = function (response) {
                            setTimeout(function () {
                                atmosphereService.subscribe(request);
                            }, request.reconnectInterval);
                        };

                        atmosphereService.subscribe(request);

                        isAtmosphereSetup = true;
                    };
                }

                $scope.$on('$stateChangeStart', function (event) {
                    $( "body").off('click');
                });

                $scope.menuMove = function(e) {
                    logger('menuMove')
                    //select item's checkbox
                    var el = e.target;
                    var checkbox = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[type=checkbox]');
                    checkbox.checked = true;

                    var menu = $scope.getMenuLocationFromMenuItem(el);
                    menu.style.display = 'none';

                    //open modal to move
                    $scope.openModal('Move');
                }

                $scope.getMenuLocationFromMenuItem = function(el) {
                    logger('getMenuLocationFromMenuItem')
                    var locations = [
                        {nodeName: 'LI', level: 2},
                        {nodeName: 'IMG', level: 5},
                        {nodeName: 'DIV', level: 3},
                        {nodeName: 'SPAN', level: 4}
                    ];

                    var lookupLevel = locations.find(p => p.nodeName === el.nodeName);

                    if(lookupLevel) {
                       while(lookupLevel.level > 0) {
                           if(el.parentElement) {
                               el = el.parentElement;
                           } else {
                               break;
                           }
                           lookupLevel.level--;
                       }

                       return el;
                    }

                    return el;
                }

                $scope.menuCopy = function(e) {
                    logger('menuCopy')
                    var el = e.target;
                    //select item's checkbox
                    var checkbox = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[type=checkbox]');
                    checkbox.checked = true;

                    var menu = $scope.getMenuLocationFromMenuItem(el);
                    menu.style.display = 'none';

                    //open modal to copy
                    $scope.openModal('Copy');
                }

                $scope.menuDelete = function(e) {
                    logger('menuDelete')
                    var el = e.target;
                    var checkbox = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[type=checkbox]');
                    checkbox.checked = true;

                    var menu = $scope.getMenuLocationFromMenuItem(el);
                    menu.style.display = 'none';

                    $scope.deleteItem();
                }

                $scope.hideTitleField = function(e) {
                    logger('hideTitleField')
                    var el = e.target;
                    var titleField = el;
                    var titleValue = el.value;

                    //fill title text div
                    var titleText = el.parentElement.querySelector('div.folder-title');
                    titleText.innerText = titleValue;

                    titleField.style.background='#FFFFFF';
                    if(titleValue.length) {
                        //hide input title
                        titleField.style.display = 'none';

                        //display title text div hover
                        if($scope.isPersistingTitle === false) {
                            titleText.classList.remove('ng-hide');
                            titleText.style.display = '';
                        }
                    }
                }

                $scope.handleDescriptionTextareaMouseLeave = function(e) {
                    logger('handleDescriptionTextareaMouseLeave')
                    var focusedElement = document.activeElement;

                    if(focusedElement !== e.target) {
                        $(e.target).hide();

                        if(e.target.value.length && e.target.value !== 'Enter a description') {
                            $(e.target).parent().children('p.description').val(e.target.value);
                            $(e.target).parent().children('p.description-no-hover').hide();
                            $(e.target).parent().children('p.create-folder-description-placeholder').hide();
                            $(e.target).parent().children('p.description-no-hover').val(e.target.value);
                            $(e.target).parent().children('p.description').show();
                        } else {
                            $(e.target).parent().children('p.create-folder-description-placeholder').show();
                        }
                    }
                }

                $scope.hideDescriptionField = function(e) {
                    logger('hideDescriptionField')
                    var el = e.target;
                    var descriptionText = el.parentElement.querySelector('p.description');
                    var descriptionTextNoHover = el.parentElement.querySelector('p.description-no-hover');

                    //hide textarea
                    el.style.display = 'none';
                    el.style.background = '#FFFFFF';

                    if($scope.isPersistingDescription === true) {
                        //hide hover
                        descriptionText.style.display = 'none';

                        //display description no hover
                        descriptionTextNoHover.classList.remove('ng-hide');
                        descriptionTextNoHover.style.display = '';
                    } else {
                        //hide no hover
                        descriptionTextNoHover.style.display = 'none';

                        //show hover
                        var descriptionValue = el.value;
                        if(descriptionValue.trim() === '') {
                            descriptionText.innerHTML = 'Enter a description';
                        } else {
                            descriptionText.innerHTML = descriptionValue;
                        }
                        descriptionText.classList.remove('ng-hide');
                        descriptionText.style.display = '';
                    }
                }

                $scope.showMenu = function(e) {
                    logger('showMenu')
                    var menu = $(e.target).parents('div[data-xid]').find('.menu');
                    var isMenuVisible = $(menu).is(':visible');

                    //hide all menus
                    $('.menu').hide();

                    $(e.target).parents('div[data-xid]').find('textarea.description').hide();
                    var descriptionValue = $(e.target).parents('div[data-xid]').find('textarea.description').val();
                    descriptionValue = descriptionValue.length ? descriptionValue : 'Enter a description';
                    $(e.target).parents('div[data-xid]').find('p.description-no-hover').hide();
                    $(e.target).parents('div[data-xid]').find('p.description-no-hover').text(descriptionValue);
                    $(e.target).parents('div[data-xid]').find('p.create-folder-description-placeholder').hide();
                    $(e.target).parents('div[data-xid]').find('p.description').text(descriptionValue);
                    $(e.target).parents('div[data-xid]').find('p.description').show();

                    if(menu) {
                        if(!isMenuVisible) {
                            $(menu).show();
                            $(menu).attr('visible', 'true');
                        }
                    }
                }

                $('body').click(function(e) {
                    logger('body click')
                    $scope.hideMenuWhenClickOutside(e);
                    $scope.persistCreateFolderContent(e);
                });

                $('body').keydown(function(e) {
                    logger('body keydown')
                    if(e.which === 27) {
                        $('.menu').hide();
                    }
                });

                $scope.persistCreateFolderContent = function(e) {
                    logger('persistCreateFolderContent')

                    if($('#inlineFolderCreate').is(':visible')) {
                        //Will not consider:
                        //- Switch View buttons (grid and list views)
                        //- Checkbox of Create Folder card
                        if(
                            e.target.id !== 'grid' &&
                            e.target.id !== 'list' &&
                            !$(e.target).parent().find('input').hasClass('new-folder-checkbox')
                        ) {
                            var titleField;
                            if($('input.create-folder-title-grid').length) {
                                titleField = $('input.create-folder-title-grid')[0];
                            } else if($('input.create-folder-title-list').length){
                                titleField = $('input.create-folder-title-list')[0];
                            }

                            $scope.persistTitle({titleField: titleField, shouldRefreshContent: true, shouldFocusOnDescription: false});

                            // var isDoubleCreateFolder = false;
                            // if($(e.target).parent().hasClass('create-folder-button') ||
                            //     $(e.target).hasClass('create-folder-button')) {
                            //     isDoubleCreateFolder = true;
                            // }
                            //
                            // $scope.persistTitle({
                            //     titleField,
                            //     shouldRefreshContent: true,
                            //     shouldFocusOnDescription: false,
                            //     isDoubleCreateFolder
                            // });
                        }
                    }
                }

                $scope.clickHistory = [];

                $scope.persistTitleCreateFolderClickOutside = function(e) {
                    logger('persistTitleCreateFolderClickOutside')
                    if(
                        $scope.lastFocusedCFTitle &&
                        $scope.lastFocusedCFTitle.nodeName === 'INPUT' &&
                        ($scope.lastFocusedCFTitle.classList.contains('create-folder-title-grid') || $scope.lastFocusedCFTitle.classList.contains('create-folder-title-list'))
                    ) {
                        var inputTitle;
                        var titleSelector;
                        if($scope.lastFocusedCFTitle.classList.contains('create-folder-title-grid')) {
                            titleSelector = '.create-folder-title-grid';
                            inputTitle = document.querySelector(titleSelector);
                        }

                        if($scope.lastFocusedCFTitle.classList.contains('create-folder-title-list')) {
                            titleSelector = '.create-folder-title-list';
                            inputTitle = document.querySelector(titleSelector);
                        }

                        $(titleSelector).hide();
                        $(titleSelector).parent().children('div.folder-title-no-hover').hide();
                        $(titleSelector).parent().children('div.folder-title').show();
                        $(titleSelector).parent().parent().find('p.description').hide();
                        $(titleSelector).parent().parent().find('p.description-no-hover').hide();
                        $(titleSelector).parent().parent().find('p.create-folder-description-placeholder').hide();
                        $(titleSelector).parent().parent().find('textarea.description').show();
                        $(titleSelector).parent().parent().find('textarea.description').focus();

                        $scope.persistTitle({titleField: inputTitle, shouldFocusOnDescription: true});

                        $scope.lastFocusedCFTitle = null;
                    }
                }

                $scope.hideMenuWhenClickOutside = function(e) {
                    logger('hideMenuWhenClickOutside')

                    //hide menu when clicking outside menu
                    //is the clicked element part of menu?
                    var menuCandidate = $scope.getMenuLocationFromMenuItem(e.target);
                    var isMenu = menuCandidate.classList.contains('menu');

                    //or is it the menu icon?
                    var menuIconCandidate = $scope.getMenuIconLocation(e.target);
                    var isMenuIcon = menuIconCandidate.classList.contains('menu-item-container');

                    if(!isMenu && !isMenuIcon) {
                        $('.menu').hide();
                        $('.menu').attr('visible', 'false');
                    }
                }

                $scope.getMenuIconLocation = function(el) {
                    logger('getMenuIconLocation')
                    var locationsMap = [
                        {nodeName: 'IMG', location: el.parentElement.parentElement},
                        {nodeName: 'I', location: el.parentElement},
                        {nodeName: 'DIV', location: el},
                    ];

                    var searchedElement = locationsMap.find(p => p.nodeName === el.nodeName);

                    if(searchedElement) {
                        return searchedElement.location;
                    }

                    return el;
                }

                $scope.handleDescriptionMouseOver = function(e) {
                    logger('handleDescriptionMouseOver')

                    var titleValue = $(e.target).parent().parent().find('input.folder-title').val();

                    if(titleValue.length) {
                        $(e.target).hide();
                        $(e.target).parent().children('textarea.description').val(e.target.value);
                        $(e.target).parent().children('textarea.description').show();
                    }
                }

                $scope.hideMenu = function(e) {
                    logger('hideMenu')
                    var el = e.target;
                    if(el.classList.contains('menu')) {
                        el.style.display = 'none';
                        return;
                    }

                    var menu = el.querySelector('.menu');
                    if(menu) menu.style.display = 'none';
                }

                $scope.menuRename = function(e) {
                    logger('menuRename')
                    var el = e.target;

                    //Name input text field
                    var itemNameField = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[type=text]');

                    //Name text with hover
                    var itemNameText = itemNameField.parentElement.querySelector('div.folder-title');

                    //Name text no hover
                    var itemNameTextNoHover = itemNameField.parentElement.querySelector('div.folder-title-no-hover');

                    var menu = $scope.getMenuLocationFromMenuItem(el);

                    var descriptionNoHover = menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('p.description-no-hover');
                    var descriptionText = menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('p.description');
                    var descriptionPlaceholder = menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('p.create-folder-description-placeholder');
                    var descriptionField = menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('textarea');

                    if($scope.activeView === 'grid') {
                        //Hide Description with hover
                        descriptionText.style.display = 'none';

                        //Hide Description placeholder
                        descriptionPlaceholder.style.display = 'none';

                        //hide Description textarea
                        descriptionField.style.display = 'none';

                        //Show Description text no hover
                        descriptionNoHover.style.display = '';
                        var descriptionValue = descriptionField.value;
                        if(descriptionValue.trim() === '') {
                            descriptionNoHover.innerHTML = 'Enter a description';
                            descriptionText.innerHTML = 'Enter a description';
                        }
                    } else if ($scope.activeView === 'list') {

                    }

                    //Hide menu
                    menu.style.display = 'none';

                    //Hide name with hover
                    itemNameText.style.display = 'none';

                    //Hide name no hover
                    itemNameTextNoHover.style.display = 'none';

                    //Show name input
                    itemNameField.style.display = '';
                    // itemNameField.style.background = '#EDF8FF';
                    itemNameField.focus();
                    itemNameField.setSelectionRange(0, 0);
                }

                $scope.handleDescriptionNoHoverMouseLeave = function(e) {
                    logger('handleDescriptionNoHoverMouseLeave')
                    $scope.makeDescriptionEditable(e);
                }

                $scope.makeDescriptionEditable = function(e) {
                    logger('makeDescriptionEditable')
                    if($scope.isPersistingTitle === false) {
                        if($(e.target).parent().parent().find('p.description').val().length > 0) {
                            $(e.target).parent().parent().find('.create-folder-description-placeholder').hide();
                            $(e.target).parent().parent().find('p.description-no-hover').hide();
                            $(e.target).parent().parent().find('p.description').show();
                        }
                    }
                }

                $scope.makeTitleEditable = function(e) {
                    logger('makeTitleEditable')
                    var titleNoHover = e.target;
                    var titleHover = titleNoHover.parentElement.querySelector('div.folder-title');

                    //hide title no hover
                    titleNoHover.style.display = 'none';

                    //display title hover
                    titleHover.innerHTML = titleNoHover.innerHTML;
                    titleHover.classList.remove('ng-hide');
                    titleHover.style.display = '';
                }

                $scope.menuAddDescription = function(e) {
                    logger('menuAddDescription')
                    var el = e.target;

                    var itemDescriptionField = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('textarea');
                    var itemDescriptionText = itemDescriptionField.parentElement.querySelector('p.description');
                    var itemDescriptionPlaceholder = itemDescriptionField.parentElement.querySelector('.create-folder-description-placeholder');
                    var menu = $scope.getMenuLocationFromMenuItem(el);
                    var titleField = menu.parentElement.querySelector('input.folder-title');
                    var titleText = menu.parentElement.querySelector('div.folder-title');

                    //hide menu
                    menu.style.display = 'none';

                    //hide description text
                    itemDescriptionText.style.display = 'none';

                    //show textarea
                    itemDescriptionField.style.display = 'block';
                    // itemDescriptionField.style.background = '#EDF8FF';

                    //hide description placeholder
                    itemDescriptionPlaceholder.style.display = 'none';

                    //focus on textarea
                    itemDescriptionField.focus();
                    itemDescriptionField.setSelectionRange(0, 0);
                }

                $scope.calculateRowsForTextArea = function(e) {
                    logger('calculateRowsForTextArea')
                    var el = e.target;
                    var cols = el.getAttribute('cols');
                    var textLength = el.value.length;
                    var rows = Math.ceil(textLength / cols);

                    if(rows < 1) rows = 1;
                    if(rows > 2) rows = 2;

                    el.setAttribute('rows', rows < 1 ? 1 : rows);
                }

                $scope.setCarrotPosition = function(e) {
                    logger('setCarrotPosition')
                    var el = e.target;
                    if(el.createTextRange) {
                        var range = el.createTextRange();
                        range.move('character', 0);
                        range.select();
                    }
                    else {
                        if(el.selectionStart) {
                            el.focus();
                            el.setSelectionRange(0, 0);
                        }
                        else
                            el.focus();
                    }
                }

                $scope.showTitleField = function (e) {
                    logger('showTitleField')
                    var el = e.target;
                    var titleField = el.parentElement.querySelector('input');
                    el.style.display = 'none';
                    titleField.style.display = 'block';
                    titleField.value = el.innerText.trim();
                    titleField.scrollLeft = 0;
                }

                $scope.selectAllClick = function(e) {
                    logger('selectAllClick')
                    var el = e.target;
                    var checkbox;

                    if(e.target.nodeName === 'INPUT') {
                        checkbox = el;
                    } else if (e.target.nodeName === 'LABEL'){
                        checkbox = el.querySelector('input');
                    }

                    var bgcolor = checkbox.checked ? "#EDF8FF" : "#FFFFFF";

                    $('.asset-card:not(.create-folder)').each(function(index, item) {
                        $(item).css('background', bgcolor);
                    });

                    $('.button-container .btn-link-secondary').attr('disabled', !checkbox.checked);
                    $('.card-checkbox input').prop('checked', checkbox.checked);

                    $scope.manageCheckAllState();
                }

                $scope.handleSelectAllKeyPress = function(e) {
                    logger('handleSelectAllKeyPress')
                    if(e.which === 13) {
                        e.preventDefault();

                         var label = e.target.querySelector('input');
                         label.checked = !label.checked;
                        $scope.selectAllClick(e);
                    }
                }

                $scope.handleInputTitleMouseLeave = function(e) {
                    logger('handleInputTitleMouseLeave')
                    $scope.hideInputTitle(e);
                    $scope.makeDescriptionEditable(e);
                }

                $scope.hideInputTitle = function(e) {
                    logger('hideInputTitle')
                    var focusedElement = document.activeElement;

                    if(
                        focusedElement
                        && focusedElement.nodeName === 'TEXTAREA'
                        && (focusedElement.classList.contains('create-folder-description-grid') || focusedElement.classList.contains('create-folder-description-list'))
                    ) {
                        $(e.target).hide();
                        $(e.target).parent().children('div.folder-title-no-hover').hide();
                        $(e.target).parent().children('div.folder-title').show();
                    }
                }

                $scope.handleInputTitleFocus = function(e) {
                    logger('handleInputTitleFocus')
                    $scope.lastFocusedCFTitle = e.target;

                    if ($(e.target).parent().parent().find('p.description').text().length) {
                        $(e.target).parent().parent().find('textarea.description').hide();
                        $(e.target).parent().parent().find('p.description-no-hover').hide();
                        $(e.target).parent().parent().find('p.create-folder-description-placeholder').hide();
                        $(e.target).parent().parent().find('p.description').show();
                    } else {
                        $(e.target).parent().parent().find('textarea.description').hide();
                        $(e.target).parent().parent().find('p.description-no-hover').hide();
                        $(e.target).parent().parent().find('p.description').hide();
                        $(e.target).parent().parent().find('p.create-folder-description-placeholder').show();
                    }
                }

                $scope.hasFocusInCFDescription = false;
                $scope.handleDescriptionTextareaFocus = function(e) {
                    logger('handleDescriptionTextareaFocus')
                    $(e.target).parent().parent().find('input.folder-title').hide();
                    $(e.target).parent().parent().find('div.folder-title-no-hover').hide();
                    $(e.target).parent().parent().find('div.folder-title').removeClass('ng-hide');
                    $(e.target).parent().parent().find('div.folder-title').show();

                    $scope.hasFocusInCFDescription = true;
                }

                $scope.handleDescriptionTextareaBlur = function(e) {
                    logger('handleDescriptionTextareaBlur');

                    setTimeout(() => {
                        var cfDescriptionGrid = $('textarea.create-folder-description-grid') && $('textarea.create-folder-description-grid')[0];
                        var cfDescriptionList = $('textarea.create-folder-description-list') && $('textarea.create-folder-description-list')[0];

                        if(document.activeElement !== cfDescriptionGrid &&
                            document.activeElement !== cfDescriptionList) {
                            $scope.hasFocusInCFDescription = false;
                        }
                    }, 500)
                }

                $scope.renderSource = null;
            }
        });
    });

